import { Controller } from "@hotwired/stimulus"

// A minimal "add/remove a nested form row" controller, used by both
// organizations/on_call_schedules/_form.html.erb's rotation-slot picker
// (accepts_nested_attributes_for :on_call_schedule_members) and _layers.html.erb's own layer
// rotation picker (:on_call_schedule_layer_members). Adding clones the <template>, swapping the
// standard Rails NEW_RECORD placeholder (see each form's own child_index: "NEW_RECORD") for a
// unique index so each new row's inputs (and any <label for="">s pointing at them) get distinct,
// still-matching id/name/for attributes. Removing an unpersisted row just deletes it from the DOM
// outright: it was never going to be submitted as anything but blank anyway; an already-persisted
// row instead uses a plain visible _destroy checkbox rendered by the form itself (no JS involved),
// since Rails needs that row still present and marked for destruction on submit, not removed from
// the DOM.
export default class extends Controller {
  static targets = ["container", "template", "field"]

  add() {
    const uniqueIndex = Date.now()
    const content = this.templateTarget.content.cloneNode(true)

    content.querySelectorAll("[name], [id], [for]").forEach((element) => {
      if (element.name) element.name = element.name.replace("NEW_RECORD", uniqueIndex)
      if (element.id) element.id = element.id.replace("NEW_RECORD", uniqueIndex)
      // A <label for="..."> pointing at the very field the id-replacement above just renamed;
      // without also rewriting this, a dynamically-added row's label keeps referencing the
      // template's original "NEW_RECORD" placeholder and stops matching its own field's real id.
      if (element.htmlFor) element.htmlFor = element.htmlFor.replace("NEW_RECORD", uniqueIndex)
    })

    this.containerTarget.appendChild(content)
  }

  remove(event) {
    event.target.closest("[data-nested-fields-target='field']").remove()
  }
}
